
class Authenticator {

    static logout() {
        window.localStorage.clear();
        window.location.href = '/login';
    }

    static isAuthenticated() {
        const accessToken = localStorage.getItem('access_token');
        return accessToken !== undefined && accessToken !== null;
    }

}

export default Authenticator;
